import {LoadingButton} from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';
import {useSnackbar} from 'notistack';
import {useState} from 'react';

import API, {getMessagesFromApiError} from '../../api/axios';
import {apiBaseUrl} from '../../api/urls';
import {useAppDispatch} from '../../hooks/redux';
import {AMSEModuleNode} from '../../interfaces/AMSEModuleNode';
import reduxActions from '../../redux/actions';
import {CloseSnackbarAction} from '../common/CloseSnackbarButton';
import SnackbarMessages from '../common/SnackbarMessages';

interface Props extends Omit<DialogProps, 'onClose'> {
  item: AMSEModuleNode;
  action: 'device' | 'data';
  onSubmitted?: () => void;
  onClose?: () => void;
}

export const PurgeActionLabels = {
  device: 'Device',
  data: 'Transactions',
} as const;

const AMSEmoduleItemPurgeModal = ({
  item,
  action,
  onSubmitted,
  onClose,
  ...props
}: Props) => {
  const reduxDispatch = useAppDispatch();

  const {enqueueSnackbar} = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const actionLabel = PurgeActionLabels[action];
  const actionName = `Purge ${actionLabel}`;

  const submit = async (pk: number | null) => {
    setIsSubmitting(true);
    try {
      await API.post(`${apiBaseUrl}/purge`, {
        ams_emodule_ids: [pk],
        action: action === 'device' ? 'device' : 'data',
      });

      const message = `AMS eModule ${actionLabel} successfully purged`;
      enqueueSnackbar(message, {
        variant: 'success',
        action: CloseSnackbarAction,
      });
      onSubmitted?.();
      onClose?.();
      reduxDispatch(reduxActions.assets.fetchAmsEmodules);
    } catch (error: any) {
      const messages = getMessagesFromApiError(error, "STRA_8a1c079d");
      enqueueSnackbar(<SnackbarMessages messages={messages} />, {
        variant: 'error',
        action: CloseSnackbarAction,
      });
    }
    setIsSubmitting(false);
  };

  return (
    <Dialog {...props} onClose={onClose}>
      <DialogTitle>Employee: {actionName}</DialogTitle>

      <DialogContent>
        <DialogContentText>
          Are you sure you want to {actionName} of this device?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose?.()}>Cancel</Button>
        <LoadingButton
          variant="contained"
          loading={isSubmitting}
          autoFocus
          onClick={() => submit(item.id)}
          color="warning"
        >
          {actionName}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default AMSEmoduleItemPurgeModal;
